module.exports = __webpack_public_path__ + "assets/src/style/img/logo_here_and_now_in_the_north.png?ab318c57366df12ed3209cc4bc599034";